import { Component } from '@angular/core';

@Component({
  selector: 'mprd-flex-product-card-skeleton',
  templateUrl: './flex-product-card-skeleton.component.html',
})
export class FlexProductCardSkeletonComponent {
  constructor() {}
}
